import { CustomerEntryName } from '../../utils/step-engine-constants';
import {
  ADD_CUSTOMER_ENTRY,
  ADD_GLOBAL_DATA,
  ADD_PREVIOUS_STEP,
  REMOVE_CUSTOMER_ENTRY,
  REMOVE_DECLARATION_GLOBAL_DATA,
  REMOVE_DISABLED_NEXT_BUTTON,
  REMOVE_GLOBAL_DATA,
  REMOVE_PREVIOUS_STEP,
  SET_ADDITIONAL_STEP,
  SET_BACK_TO_HOME,
  SET_COVER,
  SET_PREVIOUS_COVER,
  REMOVE_PREVIOUS_COVER,
  SET_COVER_DISPLAY_NAME,
  SET_CURRENT_STEP,
  SET_CURRENT_STEP_GROUP,
  SET_CUSTOMER_ENTRY,
  SET_DISABLED_NEXT_BUTTON,
  SET_DONT_SHOW_POPUP_REDIRECT_URL,
  SET_GLOBAL_DATA_CREATED_CLAIM,
  SET_GO_TO_LOGIN_ERROR,
  SET_LAST_EDIT_STEP,
  SET_RECEIVED_STEP,
  SET_SHOW_ELIGIBILITY_MODAL,
  SET_STEP_TO_SCROLL,
  CLEAR_STEP_TO_SCROLL,
  SET_SHOW_ERROR_MODAL,
  SET_SHOW_RATING_MODAL,
  SET_SHOW_STEP_ACTION,
  SET_STEP_ENGINE_CREATED_BENEFIT,
  SET_STEP_ENGINE_CREATED_CLAIM,
  SET_STEP_ENGINE_DEVICE_TYPE,
  SET_STEP_ENGINE_SUBSCRIBER,
  SET_STEP_ENGINE_SUBSCRIPTION,
  SET_STEP_GROUP,
  SET_STEP_LIST_COMPONENT,
  SET_USE_CASES,
} from './step-engine-actions';

export const setReceivedStep = (received: string[]) => dispatch => {
  dispatch({
    type: SET_RECEIVED_STEP,
    payload: received,
  });
};

export const setCurrentStep = (steps: string[]) => dispatch => {
  dispatch({
    type: SET_CURRENT_STEP,
    payload: steps,
  });
};

export const setCurrentStepGroup = (stepGroup: string) => dispatch => {
  dispatch({
    type: SET_CURRENT_STEP_GROUP,
    payload: stepGroup,
  });
};

export const setStepListComponent = (stepListComponent: {}) => dispatch => {
  dispatch({
    type: SET_STEP_LIST_COMPONENT,
    payload: stepListComponent,
  });
};

export const setLastEditStep = (step: string) => dispatch => {
  dispatch({
    type: SET_LAST_EDIT_STEP,
    payload: step,
  });
};

export const setAdditionalStep = (step: string) => dispatch => {
  dispatch({
    type: SET_ADDITIONAL_STEP,
    payload: step,
  });
};

export const addPreviousStep = (sourceSteps: string[], targetStep: string[]) => dispatch => {
  dispatch({
    type: ADD_PREVIOUS_STEP,
    payload: { sourceSteps, targetStep },
  });
};

export const removePreviousStep = (targetStep: string) => dispatch => {
  dispatch({
    type: REMOVE_PREVIOUS_STEP,
    payload: { targetStep },
  });
};

export const setCover = (cover: string) => async dispatch => {
  await dispatch({
    type: SET_COVER,
    payload: cover,
  });
};

export const setPreviousCover = (previousCover: string) => async dispatch => {
  await dispatch({
    type: SET_PREVIOUS_COVER,
    payload: previousCover,
  });
};

export const removePreviousCover = () => async dispatch => {
  await dispatch({
    type: REMOVE_PREVIOUS_COVER
  });
};

export const setCoverDisplayName = (coverDisplayName: string) => async dispatch => {
  await dispatch({
    type: SET_COVER_DISPLAY_NAME,
    payload: coverDisplayName,
  });
};

export const setUseCases = (useCases: any) => async dispatch => {
  await dispatch({
    type: SET_USE_CASES,
    payload: useCases,
  });
};

export const setCustomerEntry = (customerEntry: Map<CustomerEntryName, any>) => async dispatch => {
  await dispatch({
    type: SET_CUSTOMER_ENTRY,
    payload: customerEntry,
  });
};

export const addCustomerEntry = (customerEntryName: CustomerEntryName, value: any) => async dispatch => {
  await dispatch({
    type: ADD_CUSTOMER_ENTRY,
    payload: { customerEntryName, value },
  });
};

export const removeCustomerEntry = (customerEntryName: CustomerEntryName) => async dispatch => {
  await dispatch({
    type: REMOVE_CUSTOMER_ENTRY,

    payload: { customerEntryName },
  });
};

export const addGlobalData = (key: string, value: any) => async dispatch => {
  await dispatch({
    type: ADD_GLOBAL_DATA,
    payload: { key, value },
  });
};

export const removeGlobalData = (key: string) => async dispatch => {
  await dispatch({
    type: REMOVE_GLOBAL_DATA,
    payload: { key },
  });
};

export const removeDeclarationGlobalData = (key: string) => async dispatch => {
  await dispatch({
    type: REMOVE_DECLARATION_GLOBAL_DATA,
    payload: { key },
  });
};

export const setStepEngineSubscription = (data: any) => async dispatch => {
  await dispatch({
    type: SET_STEP_ENGINE_SUBSCRIPTION,
    payload: {
      ...data,
      insuredGoods: data.insuredGoods.filter(ig => ig.active === true),
    },
  });
};

export const setStepEngineSubscriber = (data: any) => async dispatch => {
  await dispatch({
    type: SET_STEP_ENGINE_SUBSCRIBER,
    payload: data,
  });
};

export const setStepEngineCreatedClaim = data => async dispatch => {
  await dispatch({
    type: SET_STEP_ENGINE_CREATED_CLAIM,
    payload: data,
  });
};

export const setGlobalDataCreatedClaim = data => async dispatch => {
  await dispatch({
    type: SET_GLOBAL_DATA_CREATED_CLAIM,
    payload: data,
  });
};

export const setStepEngineCreatedBenefit = data => async dispatch => {
  await dispatch({
    type: SET_STEP_ENGINE_CREATED_BENEFIT,
    payload: data,
  });
};


export const setBackToHome = (backToHome: boolean) => async dispatch => {
  await dispatch({
    type: SET_BACK_TO_HOME,
    payload: backToHome,
  });
};

export const setGoToLoginError = (goToLoginError: boolean) => async dispatch => {
  await dispatch({
    type: SET_GO_TO_LOGIN_ERROR,
    payload: goToLoginError,
  });
};

export const setShowEligibilityModal = (showEligibilityModal: boolean) => async dispatch => {
  await dispatch({
    type: SET_SHOW_ELIGIBILITY_MODAL,
    payload: showEligibilityModal,
  });
};

export const setStepToScroll = (stepToScroll: string) => async dispatch => {
  await dispatch({
    type: SET_STEP_TO_SCROLL,
    payload: stepToScroll,
  });
};

export const clearStepToScroll = () => async dispatch => {
  await dispatch({
    type: CLEAR_STEP_TO_SCROLL
  });
};

export const setDisabledNextButton = (key: string, value: any) => async dispatch => {
  await dispatch({
    type: SET_DISABLED_NEXT_BUTTON,
    payload: { key, value },
  });
};

export const removeDisabledNextButton = (key: string) => async dispatch => {
  await dispatch({
    type: REMOVE_DISABLED_NEXT_BUTTON,
    payload: { key },
  });
};

export const setShowRatingModal = (showRatingModal: boolean) => async dispatch => {
  await dispatch({
    type: SET_SHOW_RATING_MODAL,
    payload: showRatingModal,
  });
};

export const setShowErrorModal = (showErrorModal: boolean) => async dispatch => {
  await dispatch({
    type: SET_SHOW_ERROR_MODAL,
    payload: showErrorModal,
  });
};

export const setShowStepAction = (showStepAction: boolean) => async dispatch => {
  await dispatch({
    type: SET_SHOW_STEP_ACTION,
    payload: showStepAction,
  });
};

export const setStepGroup = (stepGroup: string) => async dispatch => {
  await dispatch({
    type: SET_STEP_GROUP,
    payload: stepGroup,
  });
};

export const setDontShowPopupRedirectUrl = (dontShowPopupRedirectUrl: boolean) => async dispatch => {
  await dispatch({
    type: SET_DONT_SHOW_POPUP_REDIRECT_URL,
    payload: dontShowPopupRedirectUrl,
  });
};
export const setStepEngineDeviceType = (deviceType: string) => async dispatch => {
  await dispatch({
    type: SET_STEP_ENGINE_DEVICE_TYPE,
    payload: deviceType,
  });
};
